import React from 'react';

interface ChatParticipantContextValue {
  /** avatarUrl of the non-coach participant (client) in the current chat */
  clientAvatarUrl?: string;
  /** uid of the non-coach participant (client) in the current chat */
  clientUid?: string;
}

const ChatParticipantContext = React.createContext<ChatParticipantContextValue>({});

export const ChatParticipantProvider = ChatParticipantContext.Provider;

export const useChatParticipant = (): ChatParticipantContextValue =>
  React.useContext(ChatParticipantContext);

export default ChatParticipantContext;
